const order_bot = {
  //
}

export default order_bot
